import { defineComponent as o, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as c, renderSlot as l, createElementVNode as s } from "vue";
import m from "../CdrIcon.vue.mjs";
const d = /* @__PURE__ */ s("path", {
  role: "presentation",
  d: "M16.77 8.645a1 1 0 10-1.533-1.286l-5.95 7.083-1.52-1.817a1 1 0 10-1.533 1.285l2.227 2.66a.999.999 0 001.565.1l6.743-8.025z"
}, null, -1), f = /* @__PURE__ */ o({
  name: "CheckSm",
  __name: "check-sm",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, i) => (r(), a(m, n(p(e.props)), {
      default: c(() => [l(t.$slots, "default"), d]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
